import * as React from "react";
const SvgPencil = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, fill: "none", viewBox: "0 0 25 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.499 21q.12.015.24 0l4-1a1 1 0 0 0 .47-.26l12.29-12.33a2 2 0 0 0 0-2.82L19.919 3a2 2 0 0 0-2.83 0L4.799 15.29a1.06 1.06 0 0 0-.27.47l-1 4a1 1 0 0 0 .73 1.24q.12.015.24 0m14-16.59L20.089 6l-1.59 1.59L16.919 6zm-12.09 12.1 9.09-9.1L17.089 9l-9.1 9.1-2.11.52z" }));
export default SvgPencil;
